import { Flex, Box } from '@radix-ui/themes';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ModalConfirmation from '../../../shared/ModalConfirmation';
import { GoalsHeader, YearTable } from './';
import { useGoalsLogic } from '../hooks/useGoalsLogic';
import NavigationGuard from '../../../shared/NavigationGuard';

const GoalsContent = ({
  years,
  groupedGoals,
  recentlyMovedGoalId,
  setRecentlyMovedGoalId,
  currentTargetPosition,
  activeGoal,
}) => {
  const { t } = useTranslation('goals');

  const {
    isAddingGoal,
    setIsAddingGoal,
    newGoal,
    setNewGoal,
    addGoal,
    handleCancelAdd,
    handleKeyDown,
    editingId,
    editData,
    setEditData,
    startEditing,
    saveEdit,
    deleteGoal,
    copyGoal,
    showUnsavedChangesModal,
    setShowUnsavedChangesModal,
    hasUnsavedChanges,
    setPendingAction,
    handleCancelEdit,
    handleDiscardChanges,
    handleCloseModal,
  } = useGoalsLogic(setRecentlyMovedGoalId);

  return (
    <NavigationGuard
      hasUnsavedChanges={hasUnsavedChanges}
      showUnsavedChangesModal={showUnsavedChangesModal}
      setShowUnsavedChangesModal={setShowUnsavedChangesModal}
      setPendingAction={setPendingAction}
    >
      <Flex direction="column" gap="5" p="5">
        <GoalsHeader onAddGoal={() => setIsAddingGoal(true)} />

        <Flex direction="column" gap="5">
          {years.map((year, index) => {
            const yearGoals = groupedGoals[year] || [];
            const isAddingToThisYear = isAddingGoal && index === 0;

            return (
              <YearTable
                key={year}
                year={year}
                yearGoals={yearGoals}
                isAddingToThisYear={isAddingToThisYear}
                newGoal={newGoal}
                setNewGoal={setNewGoal}
                onAddGoal={addGoal}
                onCancelAdd={handleCancelAdd}
                onKeyDown={handleKeyDown}
                editingId={editingId}
                editData={editData}
                setEditData={setEditData}
                startEditing={startEditing}
                saveEdit={saveEdit}
                cancelEdit={handleCancelEdit}
                deleteGoal={deleteGoal}
                copyGoal={copyGoal}
                recentlyMovedGoalId={recentlyMovedGoalId}
                currentTargetPosition={currentTargetPosition}
                activeGoal={activeGoal}
              />
            );
          })}
        </Flex>

        <Dialog open={showUnsavedChangesModal} onClose={handleCloseModal}>
          <Box p="24px" width="587px">
            <ModalConfirmation
              header={t('unsavedHeader')}
              body={''}
              submitText="Stay on Page"
              cancelText="Leave Page"
              variant="primary"
              cancelMode="outline"
              cancelVariant="black"
              onSave={handleCloseModal}
              onCancel={handleDiscardChanges}
            />
          </Box>
        </Dialog>
      </Flex>
    </NavigationGuard>
  );
};

export default GoalsContent;
